import React, { useState } from "react";
import { EC_Modal, UI_Modal, UI_Modal_project } from "../../UiComponents/index";
import "./Dashboard.css";
import Dropdown_CardResolution from "../../Components/Dropdown/Dropdown_CardResolution";

function UserInputModal(props) {
  const {
    newProjectInputModalOpen,
    setNewProjectInputModalOpen,
    renameModal,
    setRenameModal,
    projectName,
    setProjectName,
    handleNewProjectName,
    handleRenameProjec,
    ProjectType,
    setProjectType,
    setResolution,
  } = props;

  const handleKeypress = (e) => {
    if (e.key === "Enter" && (e.code === "Enter" || e.code === "NumpadEnter")) {
      newProjectInputModalOpen ? handleNewProjectName() : handleRenameProjec();
    }
  };

  const handleSelectType = (type) => {
    setProjectType(type);
  };

  const disabled = newProjectInputModalOpen
    ? !projectName
    : !renameModal?.title;

  return (
    <>
      <UI_Modal_project
        isOpen={
          newProjectInputModalOpen
            ? newProjectInputModalOpen
            : renameModal?.isOpen
        }
        closeModal={() =>
          newProjectInputModalOpen
            ? setNewProjectInputModalOpen(false)
            : setRenameModal((prev) => ({ ...prev, isOpen: false }))
        }
        title={
          newProjectInputModalOpen
            ? ProjectType === "scroll"
              ? "Create Scroll Project"
              : "Create Card Project"
            : renameModal?.isOpen
            ? ProjectType === "scroll"
              ? "Rename Scroll Project"
              : "Rename Card Project"
            : ""
        }
      >
        <div className="flex px-2   m-2 items-start text-white h-full">
          <input
            type="text"
            className="w-full mt-[0px] text-white px-[10px]  user_input CreateProject  placeholder:text-white placeholder:manrope-400"
            value={
              newProjectInputModalOpen ? projectName : renameModal?.title
            }
            placeholder={
              ProjectType === "scroll"
                ? "Enter Scroll Project Name"
                : "Enter Card Project Name"
            }
            onChange={(e) => {
              if (newProjectInputModalOpen) {
                setProjectName(e.target.value);
              } else {
                setRenameModal((prev) => ({
                  ...prev,
                  title: e.target.value,
                }));
              }
            }}
            onKeyDown={handleKeypress}
          />
        </div>

        <div className="flex flex-row px-2 mx-2 my-3 items-center justify-center text-white">
          <div className="w-full pt-4 flex flex-col justify-start items-center">
            <div className="w-full pb-3">
              <h1>What type of End Credits?</h1>
            </div>

            {renameModal?.isOpen? (
              <div className="w-full flex justify-center typeCredits items-center py-1 border-[1px] rounded-lg border-[#ffffffcc]">

                {renameModal?.isCard === true ? (

                  <div className={`w-1/2 px-4 py-1 rounded-xl cursor-pointer  flex items-center justify-center text-[18px] manrope-400  
                    ${ProjectType === "card" ? " " : ""}`} onClick={() => handleSelectType("card")}>
                    <span className={`inline-block   ${ProjectType === "card" ? "text-[#c0b0ff] manrope-600" : "bg-transparent"}`}>
                      Static Cards
                    </span>
                  </div>
                 
                ) : (
                  <div className={`w-1/2 px-4 cursor-pointer rounded-xl py-1 flex items-center justify-center text-[18px] manrope-400  
                    ${ProjectType === "scroll" ? "" : ""}`} onClick={() => handleSelectType("scroll")}>
                    <span className={`inline-block ${ProjectType === "scroll" ? "text-[#c0b0ff] manrope-600" : "bg-transparent"}`}>
                      Scrolling
                    </span>
                  </div>
                )}

              </div>
            ) : (
              <div className="w-full flex justify-center typeCredits items-center py-1 border-[1px] rounded-lg border-[#ffffffcc]">

                <div className={`w-1/2 px-4 cursor-pointer rounded-xl py-1 flex items-center justify-center text-[18px] manrope-400
                  ${ProjectType === "scroll" ? "" : ""}`} onClick={() => handleSelectType("scroll")}>
                  <span className={`inline-block ${ProjectType === "scroll" ? "text-[#c0b0ff] manrope-600" : "bg-transparent"}`}>
                    Scrolling
                  </span>
                </div>

                <div className="flex justify-center text-2xl mx-[20px]">
                  <span className="h-[20px]" style={{ borderLeft: "0.1px solid gray" }}/>
                </div>

                <div className={`w-1/2 px-4 py-1 rounded-xl cursor-pointer  flex items-center justify-center text-[18px] manrope-400  
                  ${ProjectType === "card" ? " " : ""}`} onClick={() => handleSelectType("card")}>
                  <span className={`inline-block ${ProjectType === "card" ? "text-[#c0b0ff] manrope-600" : "bg-transparent"}`}>
                    Static Cards
                  </span>
                </div>

              </div>
            )}
          </div>
        </div>

        {ProjectType === "card" && (
          <div className="w-full h-full">
            <div className="mt-[.5rem] flex h-[60px] justify-between items-center  ">
              <h1 className="text-left text-white  text-[16px] manrop-400 pl-4">
                Choose Resolution
              </h1>
              <Dropdown_CardResolution setResolution={setResolution} />
            </div>
          </div>
        )}

        <div className="w-full flex justify-end items-center pt-3 ">
          <div className="w-[60%]  flex flex-row justify-between pr-4">
            <button
              className="cancel_btn_ui text-lg "
              onClick={() => {
                if (newProjectInputModalOpen) {
                  setNewProjectInputModalOpen(false);
                  setProjectType("scroll");
                } else {
                  setRenameModal((prev) => ({
                    ...prev,
                    isOpen: false,
                    title: "",
                  }));
                }
              }}
            >
              Cancel
            </button>
            <button
              className="submit_btn_ui text-lg"
              onClick={
                newProjectInputModalOpen
                  ? handleNewProjectName
                  : handleRenameProjec
              }
              disabled={disabled}
            >
              Create
            </button>
          </div>
        </div>
      </UI_Modal_project>
    </>
  );
}

export default UserInputModal;
